import { useAuthInfo } from "../../../context/AuthContext";
import FormFieldSelect from "../../input/FormFieldSelect";

const OrganizationSelect = ({
  orgId,
  orgsData,
  handleFieldUpdate,
  isDisabled: isDisabledProp,
  ...props
}) => {
  const { userInfo } = useAuthInfo();
  const isSuperAdmin = userInfo?.role?.name === "super-admin";
  const isDisabled = isDisabledProp ?? !isSuperAdmin;

  const organizationOptions =
    orgsData?.results ||
    (userInfo?.organization
      ? [userInfo.organization]
      : userInfo?.org_id
        ? [
            {
              org_id: userInfo.org_id,
              name: userInfo.organization?.name || "Current organization",
            },
          ]
        : []);

  const renderOrganizations = () => {
    return organizationOptions.map((org) => {
      return (
        <option key={org.org_id} value={org.org_id}>
          {org.name}
        </option>
      );
    });
  };

  return (
    <FormFieldSelect
      name="orgId"
      label="Organization *"
      placeholder="Select Organization..."
      value={orgId}
      onChange={handleFieldUpdate}
      renderOptions={renderOrganizations}
      isDisabled={isDisabled}
      {...props}
    />
  );
};

export default OrganizationSelect;
